/** Cloud Functions region. Must match the Firestore location's region (see plans/README.md, owner inputs). */
export const FUNCTIONS_REGION = 'us-central1';

export const EMULATOR_PORTS = { auth: 9099, firestore: 8080, functions: 5001, storage: 9199, ui: 4000 } as const;

export const APP_NAME = 'VetsRelief ITSM Portal';
export const COMPANY_NAME = 'Vets Relief Solutions LLC';
